module.exports = __webpack_public_path__ + "img/turkey-water-use.49947dd8.png";